
// 教学相关接口
import request from '@/utils/request'

// 教学分类----------------------------
// 教学分类列表
export function typeList(query) {
  return request({
    url: '/biz/teachingType/list',
    method: 'get',
    params: query
  })
}
// 教学分类列表
export function getTypes(query) {
  return request({
    url: '/biz/teachingType/listAll',
    method: 'get',
    params: query
  })
}
// 新增教学分类
export function addType(params) {
  return request({
    url: '/biz/teachingType/add',
    method: 'post',
		data: params
  })
}
// 编辑教学分类
export function editType(params) {
  return request({
    url: '/biz/teachingType/edit',
    method: 'post',
		data: params
  })
}
// 删除教学分类
export function delType(id) {
  return request({
    url: `/biz/teachingType/remove?id=${id}`,
    method: 'get',
  })
}


// 教学内容---------------------------
// 教学列表
export function teachList(query) {
  return request({
    url: '/biz/teaching/pageList',
    method: 'get',
    params: query
  })
}
// 新增教学
export function addTeach(params) {
  return request({
    url: '/biz/teaching/add',
    method: 'post',
		data: params
  })
}
// 编辑教学
export function editTeach(params) {
  return request({
    url: '/biz/teaching/edit',
    method: 'post',
		data: params
  })
}
// 删除教学
export function delTeach(id) {
  return request({
    url: `/biz/teaching/remove?id=${id}`,
    method: 'get',
  })
}